var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v(" "+_vm._s(_vm.dictionary[_vm.DictionaryField.DCC_PLANRESULTS_YOUHAVEPLANNEDTOHAVE])+" "),_c('span',[_vm._v(_vm._s(_vm.days))]),_vm._v(" "+_vm._s(_vm.dayText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }